// extracted by mini-css-extract-plugin
export default {"preloader":"QaV53","buttonText":"qDUfg"};